var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"card"},[_c('v-card-text',{staticClass:"pa-3"},[_c('line-chart',{attrs:{"data":_vm.data.h,"xtitle":"Last 24h","ytitle":"Blocked","dataset":{borderWidth: 3}}}),_vm._v(" "+_vm._s(_vm.data.all)+"\n  ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/statistics/SiteViewStatistic.vue?vue&type=template&id=00ed218a&
// module id = null
// module chunks = 